export default class {
    /**
     * Constructs the the Drug.
     * @constructor
     * @constructs Drug
     * @param {object} drug - A drug object containing the id, din, drugName, and strength
     */
    constructor(drug) {
        this.id = drug.id;
        this.din = drug.din;
        this.drugName = drug.drugName.toTitleCase();
        this.strength = drug.strength;
        this.label = `<strong>${this.drugName}</strong>, ${this.strength}. DIN: ${this.din}`;
    }
}


// WEBPACK FOOTER //
// ../D:/builds/ACES/Pharmacy Compass Production Support/PharmacyCompass2/Content/scripts/drugs.js